import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_ALLERGIES' as const;
export { ExportStatus as Status };
